<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      Message Configurator
      <b-button slot="right" type="is-primary" @click="$router.go(-1)">
        <span>Back</span>
      </b-button>
    </hero-bar>
    <section class="section is-main-section">
      <messageConfigurator />
    </section>
  </div>
</template>

<script>
import messageConfigurator from "@/components/Reportingtracker/messageConfigurator";
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";

export default {
  name: "MessageConfigurator",
  components: { HeroBar, TitleBar, messageConfigurator },
  computed: {
    titleStack() {
      return [
        { url: "/reportingtracker", name: "Reporting Tracker" },
        { url: "/", name: "Message Configurator" }
      ];
      // return ["Dashboard", "Message Configurator"];
    }
  },
  data() {
    return {
      isModalActive: false
    };
  }
};
</script>
